// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3rtYT","tab":"ProcedureTabs_tab__P2o4y"};